<p-confirmDialog key="batchconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="batchremoveothers" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="batchresult" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Instructions-->
<div class="ItemBorder">
	<h4 style="text-align: center">Instructions:</h4>

	<div class="AlignCenter">
		<ul>
			<li>
				<p class="InstructionText">Import a list of people that can be visited and notified when people visit them in CAASS Visitors app</p>
			</li>
			<li>
				<p class="InstructionText">Import Format: Staff ID, Email, Phone Number</p>
			</li>
			<li>
				<p class="InstructionText">NOTE: It might be easier to press export, get a file, make your changes to it, and then re-import that file.</p>
			</li>
		</ul>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onImport()">Import</button>
	<button class="btn btn-primary LeftMargin" (click)="onClearTable()">Clear Import Data</button>
	<button class="btn btn-primary LeftMargin" (click)="onDownloadTable()">Download Import Table</button>
	<button class="btn btn-primary LeftMargin" (click)="onExport()">Export</button>
	<button class="btn btn-success LeftMargin" (click)="onUpdate()">Update Visitees</button>
</div>

<!--Table-->
<div class="ItemBorder TopMargin">
	<caass-visitee-batch-table [loading]="IsLoading() == true" [lstStaff]="lstStaff"> </caass-visitee-batch-table>
</div>
